"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabScrollButton = exports.DISPLAY_TYPE = exports.SCROLL_DIRECTION = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _iconConst = require("../icons/iconConst");

var _IconButton = require("../buttons/IconButton");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SCROLL_DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right'
};
exports.SCROLL_DIRECTION = SCROLL_DIRECTION;
var DISPLAY_TYPE = {
  AUTO: 'auto',
  ON: 'on',
  OFF: 'off'
};
exports.DISPLAY_TYPE = DISPLAY_TYPE;

var TabScrollButton = function TabScrollButton(_ref) {
  var cashbotName = _ref.cashbotName,
      direction = _ref.direction,
      handleClick = _ref.handleClick,
      visible = _ref.visible,
      displayType = _ref.displayType;
  var buttonClass = (0, _dedupe.default)('tab-scroll-button', {
    'tab-scroll-button--auto': displayType === DISPLAY_TYPE.AUTO
  });
  var buttonProps = {
    cashbotName: cashbotName,
    atts: {
      'aria-hidden': true,
      // We want to hide these from Assistive Technologies
      tabIndex: -1
    },
    ariaLabel: '',
    cssClass: buttonClass,
    icon: direction === SCROLL_DIRECTION.LEFT ? _iconConst.CHEVRON_LEFT : _iconConst.CHEVRON_RIGHT
  };

  if (!visible) {
    return _react.default.createElement("div", {
      className: buttonClass
    });
  }

  return _react.default.createElement(_IconButton.IconButton, _extends({
    onClick: handleClick
  }, buttonProps));
};

exports.TabScrollButton = TabScrollButton;
TabScrollButton.defaultProps = {
  handleClick: function handleClick() {},
  visible: true,
  displayType: DISPLAY_TYPE.AUTO
};
TabScrollButton.propTypes = {
  cashbotName: _propTypes.default.string.isRequired,

  /**
   * Which direction should the button indicate?
   */
  direction: _propTypes.default.oneOf([SCROLL_DIRECTION.LEFT, SCROLL_DIRECTION.RIGHT]).isRequired,

  /**
   * Callback to execute for button press.
   */
  handleClick: _propTypes.default.func,

  /**
   * Should the button be present or just consume space.
   */
  visible: _propTypes.default.bool,

  /**
   * Determine behavior of scroll buttons when tabs are set to scroll
   * `auto` will only present them on medium and larger viewports
   * `on` will always present them
   * `off` will never present them
   */
  displayType: _propTypes.default.oneOf([DISPLAY_TYPE.AUTO, DISPLAY_TYPE.ON, DISPLAY_TYPE.OFF])
};